// extracted by mini-css-extract-plugin
export default {"fab":"FloatingHelpButton_fab__3Bpzb","fabPressed":"FloatingHelpButton_fabPressed__ppFqv"};